import { StoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";
import { PreferredStoreButtonProps } from "@omni/types/components/props/preferredStoreButton.props";
import { Button } from "@omni/ui/components/Button/button.component";
import { isDefined } from "@omni/utils/helper.utils";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import {
    GetStoreStrategy,
    StorePersistenceStrategy,
    StoreService
} from "@/services/store.service";
import { useStoreCode } from "@/utils/hooks/store/useStoreCode.hook";

const PreferredStoreButton = ({
    storeId,
    storeType
}: PreferredStoreButtonProps) => {
    const customer = useSelector(CustomerSelectors.getCustomer);
    const dispatch = useThunkDispatch();
    const { t } = useGranite();

    const preferredStoreId = useStoreCode({
        strategy: GetStoreStrategy.Customer
    });

    const preferredDriveInStoreId = useStoreCode({
        strategy: GetStoreStrategy.DriveIn
    });

    const isDriveIn = storeType === StoreType.DriveIn;

    const isPreferredStore =
        storeId === preferredStoreId || storeId === preferredDriveInStoreId;

    const handleOnMakePreferredStoreClick = () => {
        if (isPreferredStore) {
            StoreService.removeStoreCode(
                isDriveIn
                    ? StorePersistenceStrategy.PreferredDriveIn
                    : StorePersistenceStrategy.Preferred
            );
        } else {
            StoreService.setStoreCode(
                isDriveIn
                    ? StorePersistenceStrategy.PreferredDriveIn
                    : StorePersistenceStrategy.Preferred,
                storeId
            );
        }

        if (isDefined(customer)) {
            dispatch(
                CustomerModule.updateFromData({
                    ...customer,
                    favouriteStoreId: isPreferredStore ? null : storeId
                })
            );
        }
    };

    const icon = isPreferredStore ? "check-square" : "stop";

    return (
        <Button
            type="button"
            onClick={handleOnMakePreferredStoreClick}
            color="gray"
        >
            <i className={`las la-${icon} mr-2`} />
            {t(`store.detail.preferredStore.button.${!!isPreferredStore}`)}
        </Button>
    );
};

export { PreferredStoreButton };
